<template>
    <section>
        <div class="contact_section2" style="display: flex; align-items: center; position: relative; padding-bottom: 267px;">
            <div class="con_wrap" style="padding-top: 112px">
                <div data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out"  style="display: flex; justify-content: space-between;">
                    <p style="font-size: 40px; font-weight: 700; color: black">제휴 문의</p> 
                    <div style="font-weight: 400; font-size: 20px; color: #5A5A5A">
                        <p style="margin-bottom: 39px; line-height: 1.5;">
                            경기도 안양시 동안구 시민대로 327번길 11-41, 5층 507호<br>
                            5F, 11-41, Simin-daero 327bean-gil, Dongan-gu,<br>
                            Anyang-si, Gyeonggi-do, Republic Korea
                        </p> 
                        <p @click="copy(adminEmail)" style="line-height: 1.5; text-decoration: underline; cursor: pointer;">
                            {{adminEmail}}
                            <span>
                                <img src="@/assets/images/icon/icon-copy.svg" alt="">
                            </span>
                        </p> 
                    </div>
                </div>
            </div>
        </div>
        <SnackBar v-if="showSnackBar" :info="snackbarInfo" @close="showSnackBar = false" />
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar
    },
    data() {
        return {
            webUrl: "https://www.pulda.net",
            appleUrl: "https://apps.apple.com/app/id1530892838",
            googleUrl:
                "https://play.google.com/store/apps/details?id=com.filledu.pulda2",
            adminEmail: 'mesen@filledyou.com',
            showSnackBar: false,
            snackbarInfo: {
                text: '',
                icon: '',
                color: '',
                background: ''
            },
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        copy(val) {
            navigator.clipboard.writeText(val).then(()=> {
                this.$store.commit('SET_SNACK_BAR_INFO' , {
                    text: '메일주소가 복사되었습니다.',
                    icon: 'icon-check.svg',
                    color: 'white',
                    background: '#1C9CD3'
                })
                this.showSnackBar = true
            })
        },
    }
    
}
</script>
<style>
    .contact_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
</style>